import type { OrderEventListFiltersShared } from '@klear/order-event/order-event-list-filters-shared.wire'
import { trpc } from '@klear/ui/lib/trpc'
import {
  isSharedOrderEventListQueryEnabled,
  type SharedOrderEventListQueryOptions
} from '@klear/ui/hooks/order-event-list-query-options'
import type { InvoiceOffer } from '@klear/invoice-offer/invoice-offer'

export type InvoiceOfferListFilters = OrderEventListFiltersShared & {
  fundingOrganizationId?: number
  replayEndDate?: string
  skipTraderScope?: boolean
  fundedEffectiveStartDate?: string
  fundedEffectiveEndDate?: string
  enrichLifecycleEffectiveDates?: boolean
  hasUnpaidLateFee?: boolean
  isAutoPriced?: boolean
}

const EMPTY_OFFERS: InvoiceOffer[] = []

export function useInvoiceOffers(filters?: InvoiceOfferListFilters, options?: SharedOrderEventListQueryOptions) {
  const isEnabled = isSharedOrderEventListQueryEnabled(filters, options)

  const { data, error, isLoading, isFetching, refetch } = trpc.invoiceOffer.list.useQuery(filters ?? {}, {
    enabled: isEnabled
  })

  const offers = data ?? EMPTY_OFFERS

  return { offers, error, isLoading, isFetching, refetch }
}
